import React from 'react';

const EmailSent = (props: object) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10449_9006)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.7633 46.701H6.56135C2.93989 46.701 -0.00585938 43.7546 -0.00585938 40.1338V14.4422C-0.00585938 10.8208 2.9406 7.875 6.56135 7.875H42.7629C46.3837 7.875 49.3302 10.8208 49.3302 14.4422V40.1338C49.3302 43.7546 46.3837 46.701 42.7629 46.701H42.7633Z"
          fill="#FBE201"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.13153 45.7311C2.71668 45.4755 2.33172 45.1753 1.98438 44.8371L15.7811 22.7705C16.2758 22.0726 17.5358 22.8088 16.9199 23.6778L3.13153 45.7311ZM48.0094 44.0795C47.7098 44.4764 47.3663 44.8385 46.9863 45.1584L32.4038 23.6793C31.7959 22.8524 33.0138 22.0526 33.5432 22.7722L48.009 44.0795H48.0094Z"
          fill="#FBB701"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.735352 11.4149C1.83188 9.31325 4.03197 7.875 6.56147 7.875H42.7631C45.2701 7.875 47.4529 9.28723 48.5593 11.3579L31.8495 25.0693C27.9622 28.2337 21.5244 28.3571 17.6255 25.192L0.735352 11.4149Z"
          fill="#FBB701"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.6156 52.1272C42.3352 52.1272 37.2256 47.0173 37.2256 40.7373C37.2256 34.4573 42.3349 29.3477 48.6156 29.3477C54.8962 29.3477 60.0055 34.4569 60.0055 40.7373C60.0055 47.0173 54.8959 52.1272 48.6156 52.1272Z"
          fill="#006AF9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.745 44.6371C46.5654 44.6371 46.385 44.5682 46.2476 44.4307L43.5954 41.7785C42.9397 41.1228 43.936 40.1293 44.5899 40.7839L46.7447 42.939L52.6404 37.0426C53.2961 36.3869 54.2896 37.3836 53.6353 38.0375L47.2421 44.4307C47.105 44.5682 46.9247 44.6371 46.7454 44.6371H46.745Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_10449_9006">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmailSent;
